import { FC, ReactElement, useContext } from 'react';
import { Trans, useTranslation } from 'react-i18next';

import { TicketContext } from '../../contexts/TicketContext';
import { ActionContainer } from '../ActionContainer/ActionContainer';
import WhatsAppButton from '../WhatsAppButton/WhatsAppButton';
import style from './WhatsAppLink.module.scss';


const WhatsAppLink: FC = (): ReactElement | null => {
  const { t } = useTranslation();
  const { ticket } = useContext(TicketContext);

  if (!ticket) {
    return null;
  }

  return (
    <ActionContainer bgClassName={style.containerBG} innerStyle={style.containerInner}>
      <div className={style.row}>
        <span className={style.header}>{t('contact:chatWithWhatsApp')}</span>
        <img alt="whatsapp" height={64} src="/assets/green_callouts.png" width={64} />
      </div>
      <p className={style.p}><Trans i18nKey="contact:chatWithWhatsAppDescription"/></p>
      <WhatsAppButton variant="regularButton" />
    </ActionContainer>
  );
};

export default WhatsAppLink;
